import { type ValidAppRegion } from "utils/regionUtils";
import { type Language } from "./interfaces";

const getRegionConfig = (region: ValidAppRegion) => {
    let additionalLanguages = [] as Language[];
    if (region.endsWith('-CA')) {
        additionalLanguages = [
            {
                "name": "Français",
                "code": "fr-CA",
                "fallback": [
                    "fr"
                ]
            }
        ];
    }
    return {
        defaultLng: region,
        languages: [
            {
                "name": `English (${region.split('-')[1]})`,
                "code": region,
                "fallback": [
                    "en"
                ]
            },
            ...additionalLanguages
        ]
    };
};

export const mockRegions = {
    'en-US': getRegionConfig('en-US'),
    'en-CA': getRegionConfig('en-CA'),
    'en-GB': getRegionConfig('en-GB'),
    'en-IE': getRegionConfig('en-IE'),
    'en-AU': getRegionConfig('en-AU'),
    'en-NZ': getRegionConfig('en-NZ'),
    'fr-CA': getRegionConfig('fr-CA'),
};

const getApiConfig = (region: ValidAppRegion) => {
    const prefixes = {
        'en-US': 'us',
        'en-CA': 'ca',
        'fr-CA': 'ca',
        'en-GB': 'uk',
        'en-IE': 'uk',
        'en-AU': 'au',
        'en-NZ': 'au'
    };

    const cloudzones = {
        'en-US': 'eastus',
        'en-CA': 'canadacentral',
        'fr-CA': 'canadacentral',
        'en-GB': 'northeurope',
        'en-IE': 'northeurope',
        'en-AU': 'australiasoutheast',
        'en-NZ': 'australiasoutheast'
    };

    return {
        REACT_APP_GRAPHQL_API_HOST: `https://${prefixes[region]}qaproviderhubgraphql.morneaushepell.com/graphql`,
        REACT_APP_GRAPHQL_WS_HOST: `wss://${prefixes[region]}qaproviderhubgraphql.morneaushepell.com/graphql/ws`,
        REACT_APP_FILEUPLOAD_HOST: `https://symphoni-${cloudzones[region]}-fileservice-api-qa.azurewebsites.net/api`,
        REACT_APP_CREDENTIALS_HOST: `https://app-nonprod-${prefixes[region]}-ess-qa-credentialapi.azurewebsites.net/api`,
        REACT_APP_CI_REFERRAL_HOST: `https://symphoni-${cloudzones[region]}-appointment-api-qa.azurewebsites.net/api`,
        REACT_APP_DOC_REQUEST_HOST: "http://localhost:8009/api",
        REACT_APP_INCIDENT_REPORT_HOST: `https://symphoni-${cloudzones[region]}-case-api-qa.azurewebsites.net/api`,
    };
};

export const mockApiConfigs = {
    'en-US': getApiConfig('en-US'),
    'en-CA': getApiConfig('en-CA'),
    'en-GB': getApiConfig('en-GB'),
    'en-IE': getApiConfig('en-GB'),
    'en-AU': getApiConfig('en-AU'),
    'en-NZ': getApiConfig('en-AU'),
    'fr-CA': getApiConfig('en-CA'),
};
